import { useDrawerStyles } from '@batiflow/ui';
import {
  Button,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  OverlayDrawer,
  __css,
  tokens,
} from '@fluentui/react-components';
import { Dismiss20Regular, LinkMultiple20Regular } from '@fluentui/react-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LinksList } from './links-list';

const useStyles = __css({"body":{"mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1noh358"},"intro":{"Bo78w4l":0,"Cgygva":0,"yil37a":"f8ntp42","sj55zd":"fkfq4zb"}});

export interface SpaceShareLinksProps {
  spaceId: string;
  /** The caller manages the space: the button is shown (the API answers 404 to anyone else). */
  canManage: boolean;
}

/**
 * "Liens de partage" of a space (GEDX-FE-03): a button that opens a drawer with every link of the
 * space, whichever document or folder it points to, to check and revoke them.
 */
export function SpaceShareLinks({ spaceId, canManage }: SpaceShareLinksProps) {
  const { t } = useTranslation('shareLinks');
  const drawerStyles = useDrawerStyles();
  const styles = useStyles();
  const [open, setOpen] = useState(false);
  if (!canManage) return null;
  return (
    <>
      <Button
        appearance="subtle"
        icon={<LinkMultiple20Regular />}
        onClick={() => {
          setOpen(true);
        }}
      >
        {t('space.open')}
      </Button>
      <OverlayDrawer
        position="end"
        className={drawerStyles.root}
        open={open}
        onOpenChange={(_event, data) => {
          setOpen(data.open);
        }}
      >
        <DrawerHeader>
          <DrawerHeaderTitle
            heading={{ as: 'h2' }}
            action={
              <Button
                appearance="subtle"
                icon={<Dismiss20Regular />}
                aria-label={t('common:actions.close')}
                onClick={() => {
                  setOpen(false);
                }}
              />
            }
          >
            {t('space.title')}
          </DrawerHeaderTitle>
        </DrawerHeader>
        <DrawerBody>
          {open ? (
            <div className={styles.body}>
              <p className={styles.intro}>{t('space.intro')}</p>
              <LinksList
                spaceId={spaceId}
                target={null}
                showTarget
                label={t('space.listLabel')}
                emptyText={t('space.empty')}
              />
            </div>
          ) : null}
        </DrawerBody>
      </OverlayDrawer>
    </>
  );
}


import "/opt/batiflow/app/apps/web/src/features/share-links/space-links.griffel.css";